import { render, staticRenderFns } from "./leave_history.vue?vue&type=template&id=765a986e&scoped=true&"
import script from "./leave_history.vue?vue&type=script&lang=js&"
export * from "./leave_history.vue?vue&type=script&lang=js&"
import style0 from "./leave_history.vue?vue&type=style&index=0&id=765a986e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a986e",
  null
  
)

export default component.exports